import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import throttle from "lodash/throttle";
import Link from "../components/link.js";
gsap.registerPlugin(ScrollTrigger);

class NavReveal {
  constructor() {
    this.window = window;
    this.body = document.body;
    this.header = document.querySelector(".nav");

    this.lastScrollTop = 0;
    this.navVisibleOffsetHeight = this.header.offsetHeight * 0.5;
    this.prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    this.init();
    this.connect();
  }

  init() {
    // Disable animation but make sure the nav is visible
    if (this.prefersReducedMotion) {
      this.body.classList.add("nav--is-in-view");
      return;
    }

    // Enable JS-controlled nav behavior
    this.body.classList.add("nav--js-enabled");

    // Set initial state
    this.handleScroll();
    this.updateActiveNavItemState();
    this.closeMobileMenuOnClick();
  }

  connect() {
    this.window.addEventListener(
      "scroll",
      throttle(this.handleScroll.bind(this), 50),
    );
  }

  handleScroll() {
    const currentScrollTop = this.window.scrollY;
    const navScrollTrigger = document.getElementById("nav-scroll-trigger");
    const navScrollTriggerTop = navScrollTrigger
      ? navScrollTrigger.getBoundingClientRect().top
      : 0;

    if (navScrollTrigger && navScrollTriggerTop >= 0) {
      this.body.classList.add("nav--is-in-view");
    } else if (currentScrollTop <= this.navVisibleOffsetHeight) {
      this.body.classList.add("nav--is-in-view");
    } else if (currentScrollTop > this.lastScrollTop) {
      this.body.classList.remove("nav--is-in-view");
    } else if (currentScrollTop < this.lastScrollTop) {
      this.body.classList.add("nav--is-in-view");
    }

    this.lastScrollTop = currentScrollTop;
  }

  updateActiveNavItemState() {
    const links = this.header.querySelectorAll("nav a");
    links.forEach((a) => {
      if (a.hasAttribute("aria-current")) a.removeAttribute("aria-current");
      if (a.classList.contains("italic")) a.classList.remove("italic");

      new Link(a);
      const path = a.href + "/";
      const currentUrl = window.location.href;
      const isSubPath = currentUrl.startsWith(path);

      if (a.getAttribute("aria-current") === "page" || isSubPath) {
        a.classList.add("italic");
      }
    });
  }

  closeMobileMenuOnClick() {
    const handler = (e) => {
      const link = e.target.closest(".js-nav-link-mobile");
      if (!link) return;

      const closeBtn = document.querySelector("[x-dialog\\:close]");
      if (closeBtn) {
        closeBtn.click();
      }
    };

    document.addEventListener("click", handler, { capture: true });
  }
}

export default NavReveal;
